import React, { useState } from "react";
import "./MyCoreTeam.css";

export const StatCard = ({ title, value, subtitle, icon, color = "var(--primary)" }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className={`my-core-team-stat-card ${hover ? "my-core-team-stat-card:hover" : ""}`}
      style={{
        borderTop: `4px solid ${color}`,
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <p style={{ margin: 0, color: "var(--text-secondary)", fontSize: "14px", fontWeight: 500 }}>{title}</p>
          <h3 style={{ margin: "8px 0", fontSize: "28px", fontWeight: 700, color: "var(--text-primary)" }}>{value}</h3>
          {subtitle && <p style={{ margin: 0, color: "var(--text-secondary)", fontSize: "13px" }}>{subtitle}</p>}
        </div>
        {icon && (
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              background: `${color}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};
